import React from 'react';
import classnames from 'classnames';
import * as styles from './styles.module.scss';
import Icon from 'components/UI/Icon';

const Header = ({ data }) => (
  <div>
    <div className={styles.header_search}>
      <span className={classnames('cr-text-3 cr-subheader')}>
        {data.subtitle}
      </span>

      <Icon
        name={'search'}
        className={classnames('cr-text-3', styles.header_search_icon)}
      />
    </div>

    <h1 className={classnames('cr-h1', styles.header_title)}>{data.title}</h1>
  </div>
);

export default Header;
